import { addHours, addDays, addWeeks, addMonths, addYears, differenceInCalendarDays, differenceInHours, startOfWeek, format, getHours, addMinutes, differenceInMinutes, differenceInCalendarYears, differenceInCalendarQuarters, differenceInCalendarMonths, differenceInCalendarWeeks, setHours, setSeconds, } from "date-fns";
import { elementFromPosition } from "@xbs/lib-dom";
import getMinutes from "date-fns/getMinutes";
import setMinutes from "date-fns/setMinutes";
const diff = {
    year: differenceInCalendarYears,
    quarter: differenceInCalendarQuarters,
    month: differenceInCalendarMonths,
    week: differenceInCalendarWeeks,
    day: differenceInCalendarDays,
    hour: differenceInHours,
    minute: differenceInMinutes,
};
const add = {
    year: addYears,
    month: addMonths,
    week: addWeeks,
    day: addDays,
    hour: addHours,
    minute: addMinutes,
};
export function getDiffer(unit) {
    return diff[unit];
}
export function getAdder(unit) {
    return add[unit];
}
export function getUnitStart(unit, start, weekStartsOn = 1) {
    let t;
    switch (unit) {
        case "month":
            return new Date(start.getFullYear(), start.getMonth(), 1);
        case "year":
            return new Date(start.getFullYear(), 0, 1);
        case "week":
            return startOfWeek(start, { weekStartsOn });
        case "day":
        case "minute":
            t = new Date(start.getFullYear(), start.getMonth(), start.getDate());
            t.setHours(0, 0, 0, 0);
            return t;
        case "hour":
            t = new Date(start.getFullYear(), start.getMonth(), start.getDate());
            t.setHours(0, 0, 0, 0);
            return t;
        default:
            return new Date(start);
    }
}
export function updateDateByPos(date, e, topFactor) {
    const { node: cell, id } = elementFromPosition(e, "data-cell");
    if (!cell)
        return date;
    const { top, height } = cell.getBoundingClientRect();
    const [day, time] = `${id}`.split(":");
    const diff = differenceInCalendarDays(new Date(+day), date);
    const newDate = addDays(date, diff);
    if (time) {
        const minutePx = height / 60;
        const moveInfo = topFactor ? topFactor - top : 0;
        const minute = moveInfo / minutePx;
        newDate.setHours(0, 0, 0);
        newDate.setMinutes(+time + minute);
    }
    return newDate;
}
export function roundTimeByStep(date, step) {
    if (!step)
        return date;
    const minutes = getMinutes(date);
    return setSeconds(setMinutes(date, Math.round(minutes / step) * step), 0);
}
export function getTimeFormat(date, locale, showAM = true) {
    const _ = locale.getGroup("scheduler");
    const isAM = locale.getRaw().calendar.timeFormat === 12;
    const hourFormat = _("hourFormat");
    const minuteFormat = _("minuteFormat");
    const meridianFormat = _("meridianFormat");
    return `${hourFormat}:${minuteFormat}${showAM && isAM ? meridianFormat : ""}`;
}
export function getRangeTimeString(event, locale) {
    const { dateFnsLocale } = locale.getRaw();
    const _dates = dateFnsLocale;
    const { start_date, end_date } = event;
    const time_format = getTimeFormat(start_date, locale);
    return `${format(start_date, time_format, { locale: _dates })} - ${format(end_date, time_format, { locale: _dates })}`;
}
export function setTimeFromDate(targetDate, timeDate) {
    const hours = getHours(timeDate);
    const minutes = getMinutes(timeDate);
    return setHours(setMinutes(targetDate, minutes), hours);
}
export function isSameTime(left, right) {
    return (left.getHours() === right.getHours() &&
        left.getMinutes() === right.getMinutes());
}
export function isSameDateTime(left, right) {
    return left?.valueOf() === right?.valueOf();
}
export { format };
//# sourceMappingURL=time.js.map